import React from 'react';
import CourseComponent from 'Components/Card/Components/CourseComponent';
import TutorSessionsComponent from 'Components/Card/Components/TutorSessionsComponent';
import styles from 'assets/css/CourseComponent.module.css';
import withSMARTGoalOnUpdateCardComponent from 'Components/Card/hoc/withSMARTGoalOnUpdateCardComponent';

function LMSCourseAndTutorSessionCard(props) {

    const { Course: course, TutorSessions: tutorSessions, Locked: locked } = props.data;

    return (
        <div className={styles["live-skills"]}>
            <CourseComponent course={course} locked={locked} />
            <TutorSessionsComponent tutorSessions={tutorSessions} HasCourse={course.HasCourse} />
        </div>
    )
}

export default withSMARTGoalOnUpdateCardComponent(LMSCourseAndTutorSessionCard);
